module.exports = __webpack_public_path__ + "img/zhyly-2.854a0a5b.png";